'use client';

import { ActionIcon, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import { useSession } from 'next-auth/react';
import Link from 'next/link';

export default function CragEdit({ crag }: { crag: Crag }) {
  const { data: session } = useSession();
  if (session?.user?.role !== 'admin') return null;

  return (
    <Tooltip label='Edit' zIndex={1200}>
      <ActionIcon component={Link} href={`/crags/${crag.nameSlug}/edit`}>
        <IconEdit stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
}
